import { Badge as RSBadge } from 'reactstrap';

export default function Badge({ color, style, ...rest }) {
  const temBgInline = style && (style.background || style.backgroundColor);
  const finalColor = temBgInline && color == null ? '' : color;

  return <RSBadge color={finalColor} style={style} {...rest} />;
}
